// @flow
import api from './';

export function getFeatureControlImpressions(id: string){
    return api('get', `/api/v1/variant-daily-impressions?featureControlId=${id}`);
}